import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=6a3353c4&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3353c4",
  null
  
)

export default component.exports

/* vue-cli-plugin-import-components */
const vueCliInstallComponent = require("!../../node_modules/vue-cli-plugin-import-components/dist/runtime/installComponents.js")
import ActionHeader from "@/components/ActionHeader.vue";
import AdminClassCard from "@/components/admin/adminClassCard.vue";
import CreateInputModal from "@/components/createInputModal.vue";
import DnButton from "@/components/dn-button.vue";
import DnTable from "@/components/dn-table.vue";
import SegmentedControl from "@/components/segmentedControl.vue";
vueCliInstallComponent(component, {ActionHeader, AdminClassCard, CreateInputModal, DnButton, DnTable, SegmentedControl});